import React from 'react';
import { EIcons } from '../../../utils/globatTypes';
import { TitleBlock } from '../../TitleBlock';
import { HeaderS } from './styles';

interface ListenersProps {}

export const Listeners: React.FC<ListenersProps> = () => {
  return (
    <>
      <HeaderS>
        <TitleBlock title="Слухачі" icon={EIcons.listeners} />
      </HeaderS>
    </>
  );
};
